import { Theme, createStyles } from '@material-ui/core/styles';

export const styles = (theme: Theme) => createStyles({
    gridContainer: {
        fontFamily: 'MuseoSans, sans-serif',
        margin: '0 0 262px 28% ',
        display: 'flex',
        flexDirection: 'row',
        '& #benefits': {
          width: '90%',
            '& img': {
                height: 'auto',
                width: 'auto',
            },
        },
        [theme.breakpoints.down(1200)]: {
          margin: '0 0 262px 23%',
        },
        [theme.breakpoints.down(1001)]: {
          margin: '0 0 262px 20%',
        },
        [theme.breakpoints.down(905)]: {
          margin: '0 0 262px 16%',
        },
        [theme.breakpoints.down(850)]: {
         margin: '0 0 220px 16%',
        },
        [theme.breakpoints.down(701)]: {
          margin: '0 0 150px 0%',
          flexDirection: 'column-reverse',
          '& #benefits': {
            width: '100%',
          },
        },
        [theme.breakpoints.down(500)]: {
          margin: '0 0 120px 0%',
        },
        [theme.breakpoints.down(400)]: {
          margin: '0 0 100px 0%',
        },
    },
    textContainer: {
        width: '60%',
        marginRight: '15%',
        '& #text': {
            fontSize: '18.33px',
            fontWeight: 500,
            color: '#3D4274',
            letterSpacing: '0.75px',
            lineHeight: '26.45px',
        },
        [theme.breakpoints.down(1200)]: {
          width: '65%',
          marginRight: '10%',
        },
        [theme.breakpoints.down(1001)]: {
          width: '60%',
        },
        [theme.breakpoints.down(701)]: {
          width: '50%',
          marginRight:'0',
          marginLeft:'25%',
          marginTop:'10%'
        },
        [theme.breakpoints.down(601)]: {
          width: '55%',
        },
        [theme.breakpoints.down(550)]: {
          marginLeft:'23%',
          width: '60%',
        },
        [theme.breakpoints.down(500)]: {
          marginLeft:'23%',
          width: '65%',
        },
        [theme.breakpoints.down(400)]: {
          marginLeft:'20%',
          width: '70%',
        },
        [theme.breakpoints.down(350)]: {
          width: '75%',
        },
    },
    subtitle: {
        fontSize: '36px',
        color: '#3D4274',
        letterSpacing: '3.21px',
        lineHeight: '50px',
        fontWeight: '500',
        marginBottom: '123.39px',
        '& span': {
            fontWeight: 900,
        },
        [theme.breakpoints.down(1200)]: {
          marginBottom: '70px',
        },
        [theme.breakpoints.down(1001)]: {
          fontSize: '31px',
          lineHeight: '45px',
        },
        [theme.breakpoints.down(850)]: {
          marginBottom: '50px',
        },
        [theme.breakpoints.down(701)]: {
          marginBottom: '55px',
          fontSize: '26px',
          lineHeight: '35px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '23px',
          lineHeight: '30px',
          marginBottom: '45px',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '21px',
          lineHeight: '27px',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '19px',
          lineHeight: '25px',
        },
    },
    text: {
        fontSize: '18.3px',
        color: '#3D4274',
        letterSpacing: '0.75px',
        lineHeight: '26.35px',
        fontWeight: 500,
        margin:'0',
        [theme.breakpoints.down(1001)]: {
          fontSize: '15.5px',
          lineHeight: '25px',
        },
        [theme.breakpoints.down(701)]: {
          fontSize: '15px',
          lineHeight: '22px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '13px',
          lineHeight: '21px',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '12px',
          lineHeight: '20px',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '11px',
          lineHeight: '19px',
        },
        [theme.breakpoints.down(350)]: {
          lineHeight: '18px',
        },
    },
    straightLine: {
        borderTop: '1px solid #3D4274',
        background: 'none !important',
        margin:'0px',
    },
});
